export enum SignatureType {
  ESIGN = "ESIGN"
}